<template>
  <div class="Puploadfile _width">
    <communityHeader :router_url='router_url'></communityHeader>
    <!-- :style="{height:topHeight}" -->
    <div class="conter _width"
         :style="{height:topHeight}">
      <!--  -->
      <div class="conter_left">
        <!-- header_tag -->
        <div class="header_tag">
          <div class="href_tag _width _height ">
            <p>已添加{{imgList.length}}张图片！拖拽图片，调整顺序(最多只能添加100张)</p>

            <span style="color:red;"
                  class="photo_cover_status"
                  v-if="photo_cover_status == 3 ">{{status_type}}!
              <i></i>
              <div>{{photo_cover_text}}</div>
            </span>
            <span style="color:red;"
                  v-if="photo_cover_status !== 3 ">{{status_type}} </span>
            <!--  <span v-if="photo_cover_status == 3">{{status_type}} <div>{{}}</div> </span> -->
          </div>
        </div>
        <!-- header_tag end -->

        <!-- left_conter -->
        <div class="left_conter">
          <Loading :loading_bool="loading_bool"></Loading>

          <!-- 上传后的图片 -->
          <!-- 拖拽 -->
          <draggable v-model="imgList"
                     v-if="loading_bool ==false"
                     :move="getdata"
                     filter=".undraggable"
                     class="draggable_img"
                     @update="datadragEnd">

            <div class="updete_works"
                 v-show="imgList.length != 0"
                 v-for="(item, index) of imgList"
                 :key="index">
              <!-- 上传-->
              <div class="up_data_top no_mose">
                <img :src="item.tnUrl"
                     :alt="item.item">
                <span class="img_label"
                      v-if="item.isCover ==1">封面</span>
                <span class="img_numbel">{{index+1}}/{{imgList.length}}</span>

                <div class="up_data_top_mose _width _height">
                  <div class="ms_bottom _width">
                    <!-- <span v-if="$route.query.photoshowId"
                          @click="cover_photo(index,item.tnUrl)">设为封面</span> -->

                    <span @click="cover_photo(index,item.tnUrl,item.isCover)">设为封面</span>
                    <i>|</i>

                    <span v-if="!item.workId"
                          @click="fileDel(index)">删除照片</span>
                    <span v-if="item.workId"
                          @click="zfileDel(item.workId,index)">删除照片</span>

                  </div>
                </div>
              </div>

              <!-- 上传 下 添加描述 -->
              <div class="up_data_bottom">
                <el-input type="textarea"
                          class="common"
                          v-model="item.comments"
                          placeholder="请输入描述"></el-input>
              </div>

              <!-- 进度条 -->
              <div class="progress_bag"
                   v-if="!item.tnUrl">
                <div class="progress">
                  <div class="progress-bar progress-bar-info progress-bar-striped active"
                       style="width: 100%;">
                    <div class="progress-value">100%</div>
                  </div>
                </div>
              </div>

            </div>

            <!-- 默认上传 -->
            <div class="upload_img undraggable"
                 :class="imgList.length !=0 ? 'draggable' : 'undraggable'"
                 @click="fileClick">
              <img src="@/assets/image/community/up.png"
                   alt=""
                   class="up_img">
              <p class="up_text _width">选择图片</p>
              <p class="tt _width">支持ipg/jpeg/png/gif/bmp格式</p>
              <p class="tt _width">请上传分辨率高于<span class="font-style">1024x768</span></p>
            </div>
            <!-- 上传 input -->
            <input @change="fileChange($event)"
                   type="file"
                   id="upload_file"
                   multiple
                   style="display: none" />
          </draggable>
          <!-- 上传 -->

        </div>
        <!-- left_conter end -->
      </div>
      <div class="conter_right">
        <ul class="from_list _width">

          <!-- 标题 -->
          <li class="_width">
            <p><span>*</span>标题</p>
            <input type="text"
                   placeholder="请输入标题(最多20个字)"
                   maxlength="20"
                   v-model="photoshowData.photoshow.title">
          </li>

          <!-- 描述 -->
          <li class="_width">
            <p>描述 </p>
            <textarea name=""
                      placeholder="请输入描述"
                      v-model="photoshowData.photoshow.comments"
                      class="text_conter _width"> </textarea>
          </li>

          <!-- 权限 -->
          <li class="_width">
            <p><strong style="color:#f00">*</strong>权限</p>
            <div class="entry">
              <label>
                <input type="radio"
                       v-model="photoshowData.photoshow.authority"
                       value="1">
                <span>公开</span>
              </label>
              <label>
                <input type="radio"
                       v-model="photoshowData.photoshow.authority"
                       value="2">
                <span>仅自己可见</span>
              </label>
            </div>
          </li>

          <!-- 标签 -->
          <li class="_width">
            <p>标签</p>
            <el-input name=""
                      class="label_conter _width"
                      ref="saveTagInput"
                      size="small"
                      v-model="entrytag"
                      @keyup.enter.native="handleInputConfirm">
            </el-input>
            <span class="icon"
                  @click="handleInputConfirm"><img src="@/assets/image/community/update.png"
                   alt=""></span>

            <!-- 标签分类 -->
            <div class="label _width"
                 v-if="dynamicTags">
              <el-tag v-for="(tag,index)  in dynamicTags"
                      :key="index"
                      closable
                      :disable-transitions="false"
                      @close="handleClose(index)">
                {{tag.name}}
              </el-tag>
            </div>
          </li>
        </ul>
        <div class="update_btn _width">
          <!-- 保存 -->
          <button class="new_update _width"
                  @click="preservation()"
                  :disabled="isDisable"
                  v-ripple="'rgba(255, 255, 255, 0.25)'">
            <span></span>
            <p>保存</p>
          </button>
          <!-- 返回影展 -->
          <button class="new_update _width"
                  @click="tag_photo_show()"
                  :disabled="isDisable"
                  v-ripple="'rgba(255, 255, 255, 0.25)'">
            <span></span>
            <p>返回影展</p>
          </button>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Loading from '@/components/loading/loading.vue'
import communityHeader from '@/components/community/common/communityHeader.vue'
import draggable from "vuedraggable";
import plupload from "plupload";
import { updatePhoto_details, savePhoto, deletePhoto, setPhotoCover } from '@/utils/api/ucenter.js' //上传用户的详情
import { photoshowImgUpload, findPhotoDetail } from '@/utils/api/Puploadfile.js' //影展
export default {
  data () {
    return {
      photoshowId: this.$route.query.photoshowId,
      windowHeight: "",
      topHeight: "",
      // 标签
      entrytag: "",
      isRepeatedData: false,
      dynamicTags: [],
      tempTag: '',
      // 上传
      size: 0,
      photo_cover_text: '',//审核理由
      status_type: '',// 审核状态
      // 拖拽后的数据
      imgList: [],
      is_cover: -1, //封面

      update_lise: {
        describe: '', //描述
      },
      isDisable: false, //防止重复提交

      // coverUrl: '',//封面的url
      //增加新影展数据
      photoshowData: {
        coverUrl: '',//封面的url
        // 外层的
        photoshow: {
          authority: 1,//影展权限
          comments: "",//影展简介
          tags: "",//影展标签
          title: "",//影展名称
          workCount: 0,//影展作品数量
        },
        // 详情里面的数据
        workList: [
          {
            comments: "",//作品简介
            photoshowId: "",//影展id
            sortNo: 0,//不必要排序号
            title: "",//作品图片名称
            tnUrl: "",//缩略图地址
            workUrl: ""//原图地址
          }
        ]
      },
      // code_succes: 0,//0:未保存 1，保存成功
      loading_bool: false, //加载loading
      photo_cover_status: '',//封面审核状态
      is_cover: {},//是不是封面
    }
  },

  computed: {},
  watch: {
    topHeight (val) {
      this.topHeight = val;
    }
  },

  components: {
    draggable,
    Loading,
    communityHeader
  },
  created () {
    this.router_url = this.$route.fullPath;//当前地址url

    this.photoshowId = this.$route.query.photoshowId;
    if (this.photoshowId) {
      this.getfindPhotoDetail();
      this.getfindPhotoDetail2();
    }
  },
  mounted () {
    this.windowHeight = window.innerHeight;
    this.topHeight = (this.windowHeight - 280) + "px";
    window.onresize = () => {
      return (() => {
        this.windowHeight = window.innerHeight;
        this.topHeight = (this.windowHeight - 280) + "px";
      })();
    };


  },

  methods: {
    // 详情回显示
    update_details (params) {
      updatePhoto_details(params).then((res) => {
        let data = res.data;

        console.log(data);
      })
    },
    // 返回我的影展
    tag_photo_show () {
      // if (this.code_succes == 0) {
      //   this.$message({
      //     message: '你还没有保存！',
      //     center: true,
      //     type: 'error'
      //   });
      //   return false
      // } else {
      this.$router.push({
        path: '/Pcenter?type=2'
      })
      // }

    },

    //拖动中与拖动结束
    getdata (evt) {
      // console.log(evt.draggedContext.element.index);
    },
    datadragEnd (evt) {
      // console.log("拖动前的索引 :" + evt.oldIndex);
      // console.log("拖动后的索引 :" + evt.newIndex);
      // this.preservation(1)

    },
    //代理上传按钮
    fileClick () {
      let upload_file = document.getElementById('upload_file');
      upload_file.click();
    },
    //获取上传文件信息
    fileChange (el) {
      if (!el.target.files[0].size) return;
      this.fileList(el.target);
      el.target.value = ''
    },
    //处理上传文件
    fileList (fileList) {
      let files = fileList.files;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        // console.log(files.length);
        if (files.length >= 100) {
          this.$message({
            message: '最多只能上传100张图片',
            center: true,
            type: 'warning'
          });
          return false
        }
        formData.append("fileName", files[i])
      };
      this.UploadPhotoshowImg(formData);//上传图片接口数据

    },
    //发起上传请求
    UploadPhotoshowImg (imgFormData) {
      // console.log(this.imgList.length);
      photoshowImgUpload({
        data: imgFormData,
      }).then(res => {
        this.loading_bool = true

        if (this.imgList.length >= 100) {
          this.$message({
            message: '最多只能上传100张图片',
            center: true,
            type: 'warning'
          });
          this.loading_bool = false
          return false
        }
        if (res.data.code == 200) {
          this.loading_bool = false
          this.$message({
            message: '上传成功，可以继续上传了',
            center: true,
            type: 'success'
          });
          for (let i = 0; i < res.data.data.length; i++) {
            res.data.data[i].comments = "";
            this.imgList.push(res.data.data[i]);
          };
          // console.log(this.imgList, "上传的图片数组")
        } else {
          this.loading_bool = false
          this.$message({
            message: '上传失败，请重试...',
            center: true,
            type: 'error'
          });
        }
      })
    },

    // 设为封面
    cover_photo (index, url, isCover) {
      // 新建
      if (!this.$route.query.photoshowId) {
        // console.log(this.imgList);
        this.imgList.map((item, index_son) => {
          item.isCover = 0
          if (index_son == index) {
            if (this.is_cover.isCover == 1 && this.is_cover.ind == index) {
              item.isCover = 0
              this.is_cover = {
                isCover: 0,
                ind: index
              }
            } else {
              item.isCover = 1
              this.is_cover = {
                isCover: 1,
                ind: index
              }
              // console.log(this.imgList);
              // console.log(this.imgList[index].tnUrl);
              this.photoshowData.coverUrl = this.imgList[index].tnUrl
            }
          }
        })
      };

      // 编辑
      if (this.$route.query.photoshowId) {
        this.coverUrl = url;
        let params = {
          photoShowId: this.$route.query.photoshowId,
          tnUrl: url
        }
        setPhotoCover(params).then((res) => {
          let data = res.data
          if (data.code == 200) {
            this.$message({
              message: '设置封面成功！',
              center: true,
              type: 'success'
            });
            this.getfindPhotoDetail2();//点击标签要刷新 只刷新作品的数据//
            // this.$router.push('/Pcenter?type=2')
          } else {
            this.$message({
              message: data.message,
              center: true,
              type: 'success'
            })
          }

        })
      };

    },
    // 删除作品
    fileDel (index) {
      this.imgList.splice(index, 1);
      this.$message({
        message: '删除作品成功！',
        center: true,
        type: 'success'
      });
    },
    zfileDel (workid, index) {

      deletePhoto({
        workId: workid
      }).then(res => {
        if (res.data.code == 200) {
          this.imgList.splice(index, 1);
          this.$message({
            message: '删除作品成功！',
            center: true,
            type: 'success'
          })
        } else {
          this.$message({
            message: '删除作品失败！',
            center: true,
            type: 'error'
          })
        }
      })
    },

    // 删除接口
    savePhoto () {
      deletePhoto(params).then((res) => {
        let data = res.data;
        console.log(data);
      })
    },
    // 计算上传的大小
    bytesToSize (bytes) {
      if (bytes === 0) return '0 B';
      let k = 1000, // or 1024
        sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
      return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
    },
    // 拖拽文件夹
    drop (el) {
      el.stopPropagation();
      el.preventDefault();
      this.fileList(el.dataTransfer);
    },
    // 失败后图片

    // 添加描述
    on_input (index) {
      console.log(index);
    },


    // 添加标签
    handleInputConfirm () {
      let entrytag = this.entrytag;
      if (entrytag) {
        var values = entrytag.split(/[,， \n]/).filter(item => {
          return item != '' && item != undefined
        })
        values.forEach(element => {
          var index = this.dynamicTags.findIndex(i => {
            return i == element
          })
          if (index < 0) {
            var arr = this.dynamicTags;
            for (var i = 0; i < arr.length; i++) {
              if (arr[i].name == element) {
                this.$message({
                  message: '不可以添加重复的标签哦！',
                  center: true,
                  type: 'warning'
                });
                return false
              }
            }
            console.log(this.dynamicTags.length);
            if (this.dynamicTags.length >= 10) {
              this.$message({
                message: '最多只能添加10个标签！',
                center: true,
                type: 'warning'
              });
              return false
            }

            this.dynamicTags.push({
              name: element,
              type: 'info'
            });
            this.entrytag = ""
            // console.log(element);
            // console.log(this.dynamicTags);
          }
        });

        // this.dynamicTags.push({
        //   name: this.entrytag,
        //   type: 'info'
        // });
        // this.entrytag = ""


      } else {
        this.$message({
          message: '请输入标签内容',
          center: true,
          type: 'error'
        });
      }
    },



    //标签处理
    topictags () {
      if (this.dynamicTags) {
        let temArr = [];
        let tagstring = '';
        for (let i = 0; i < this.dynamicTags.length; i++) {
          temArr.push(this.dynamicTags[i].name)
        };
        return tagstring = temArr.join(",");

      }
    },


    // 删除标签
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },




    // 保存成功
    preservation () {
      // 防止重复点击  时间2s
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false
      }, 2000)
      if (this.imgList.length<=0) {
        this.$message({
          message: '请先上传一个图片！',
          center: true,
          type: 'warning'
        });
        return false;
      }
      // 新建的保存
      if (!this.photoshowId) {
        if (this.photoshowData.photoshow.title && this.photoshowData.photoshow.authority) {
          this.photoshowData.photoshow.photoshowId = '';
          this.photoshowData.photoshow.tags = this.topictags();
          this.photoshowData.workList = this.imgList;
          // this.is_cover.isCover =  this.imgList 
          this.photoshowData.photoshow.workCount = this.imgList.length;
          // this.photoshowData.coverUrl = this.coverUrl;
          this.photoshowData.coverUrl;
          savePhoto(this.photoshowData).then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: '作品保存成功！',
                center: true,
                type: 'success'
              });
              this.$router.push('/Pcenter?type=2')
            }
          })
        } else {
          this.$message.error('请输入标题和选择权限');
          return;
        }
        // 编辑的保存
      } else {
        if (this.photoshowData.photoshow.title && this.photoshowData.photoshow.authority) {
          this.photoshowData.photoshow.photoshowId = this.photoshowId;
          this.photoshowData.photoshow.tags = this.topictags();
          this.photoshowData.workList = this.imgList;
          this.photoshowData.photoshow.workCount = this.imgList.length;
          this.photoshowData.coverUrl = this.coverUrl;
          savePhoto(this.photoshowData).then(res => {
            if (res.data.code == 200) {
              // 拖拽后的保存
              this.$message({
                message: '作品编辑成功！',
                center: true,
                type: 'success'
              });
              // this.$router.push('/Pcenter?type=2')
            }
          })
        } else {
          this.$message.error('请输入标题和选择权限');
          return;
        }
      }
    },

    //保存封面后  详情数据2
    getfindPhotoDetail2 () {
      findPhotoDetail({
        photoshowId: this.$route.query.photoshowId
      }).then(res => {
        if (res.data.code == 200) {
          let tempdata = res.data.data;
          // console.log(tempdata);
          this.imgList = tempdata.workList;
        }
      })
    },

    // 详情数据
    getfindPhotoDetail () {
      findPhotoDetail({
        photoshowId: this.$route.query.photoshowId
      }).then(res => {
        if (res.data.code == 200) {
          let tempdata = res.data.data;
          console.log(tempdata);
          this.photoshowData.photoshow.authority = tempdata.photoshow.authority;
          this.photoshowData.photoshow.comments = tempdata.photoshow.comments;
          this.photoshowData.photoshow.tags = tempdata.photoshow.tags;
          this.photoshowData.photoshow.title = tempdata.photoshow.title;

          this.photo_cover_text = tempdata.photoshowAudit
          this.photo_cover_status = tempdata.photoshow.status
          // console.log(this.photo_cover_status);
          if (this.photo_cover_status == 0) {
            this.status_type = '审核中'
          } else if (this.photo_cover_status == 1) {
            this.status_type = '审核通过'
          } else if (this.photo_cover_status == 2) {
            this.status_type = '已下线'
          } else {
            this.status_type = '审核未通过'
          }


          if (this.photoshowData.photoshow.tags) {
            let temArr = this.photoshowData.photoshow.tags.split(",");
            for (let i = 0; i < temArr.length; i++) {
              this.dynamicTags.push({ name: temArr[i], type: 'info' })
            }

          } else {
            return
          }


        }

      })
    }
  },


}
</script>
<style>
</style>
<style scoped>
@import "../../assets/css/Ucenter/Puploadfile.css";

.photo_cover_status {
  position: relative;
  cursor: pointer;
}
.photo_cover_status:hover div {
  max-width: 500px;
  height: 200px;
  box-shadow: 0 5px 20px rgb(0 0 0 / 10%);
  opacity: 1;
}
.photo_cover_status:hover i {
  opacity: 1;
}
.photo_cover_status i {
  width: 0;
  height: 0;
  transition: all 0.3s;
  border-left: 0.07rem solid transparent;
  border-right: 0.07rem solid transparent;
  border-bottom: 0.12rem solid #fff;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, 0%);
  position: absolute;
  left: 50%;
  top: 30px;
  opacity: 0;
}
.photo_cover_status div {
  opacity: 0;
  overflow: hidden;
  padding: 10px;
  color: rgba(0, 0, 0, 0.3);
  line-height: 20px;
  font-size: 16px;
  /* max-width: 500px; */
  height: 0;
  position: absolute;
  left: 50%;
  top: 40px;
  transition: all 0.3s;
  z-index: 99;
  background-color: #fff;
  border-radius: 5px;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, 0%);
}
.font-style {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/community/Puploadfile.vue